<template>
  <span :class="_class" />
</template>
<script setup lang="ts">

import '@mdi/font/css/materialdesignicons.css'
import {computed} from "vue";

interface Props {
  icon?: string
}

const props = withDefaults(defineProps<Props>(), {
    icon: undefined
  }
)

const _class = computed(() => {
  if (props.icon) {
    return "sog-icon mdi-set " + props.icon
  }
  return "sog-icon mdi-set"
})


</script>

<style scoped>
.sog-icon {
  fill: currentColor;
}
</style>
